<template>
  <PageContainer title="Listar Aulas Realizadas">
    <div v-if="!loaded" class="d-flex justify-content-center">
      <component
        :animation-duration="1000"
        :is="'SpringSpinner'"
        :color="'#1C2D5A'"
        :size="80"
        class="mx-2"
      >
      </component>
    </div>

    <Box v-else class="aulas-container" space="medium">
      <form @submit.prevent="handleSubmit">
        <div class="inputs">
          <div class="inputs-row">
            <Select
              class="input-full"
              :filtered="true"
              :options="alunos"
              legend="Aluno"
              placeholder="Digite o nome do aluno"
              :modelValue="aluno"
              @update:modelValue="$event => (this.aluno = $event)"
              :disabled="loadingAluno || loading"
            />

            <Select
              class="input-full input-status"
              :options="statusOptions"
              legend="Status"
              placeholder="Selecione"
              :modelValue="status"
              @update:modelValue="$event => (this.status = $event)"
              :disabled="loadingAluno || loading"
            />
          </div>
          <div class="inputs-row">
            <Period
              legend="Data"
              :firstModelValue="initialDate"
              :secondModelValue="finalDate"
              @update:firstModelValue="$event => (this.initialDate = $event)"
              @update:secondModelValue="$event => (this.finalDate = $event)"
              :disabled="loading"
            />

            <div class="buttons">
              <Button
                type="button"
                @handle:click="clearInputs"
                text="Limpar"
                :fill="false"
                color="danger"
                :disabled="loading"
              >
                <CloseCircleOutline :size="18" />
              </Button>

              <Button type="submit" text="Consultar" color="primary" :disabled="loading">
                <Magnify :size="18" />
              </Button>
            </div>
          </div>
        </div>
      </form>

      <div v-if="loading" class="d-flex justify-content-center">
        <component
          :animation-duration="1000"
          :is="'SpringSpinner'"
          :color="'#1C2D5A'"
          :size="80"
          class="mx-2"
        >
        </component>
      </div>

      <template v-else-if="aulas.length > 0 && !loading">
        <div class="table-container">
          <Paginate
            :total-pages="paginationData.lastPage"
            :current-page="paginationData.currentPage"
            @page-changed="fetchAulas"
          />

          <Table
            :headers="[
              'Aluno',
              'Instrutor',
              'Veículo',
              'Categoria',
              'Turno',
              'Horário/Data',
              'Status',
              'Ações',
            ]"
          >
            <tr v-for="aula in aulas" :key="aula.id_aulas_praticas">
              <td>{{ aula.nomeAluno }}</td>
              <td>{{ aula.nomeInstrutor }}</td>
              <td>{{ aula.placa }}</td>
              <td>{{ aula.categoria_cnh }}</td>
              <td>{{ aula.tipo_aula.toUpperCase() }}</td>
              <td>{{ utils.formatDate(aula.data_aula) }}</td>
              <td>
                <span v-if="aula.status">{{ aula.status }}</span>
                <span v-else>Pendente {{ aula.status }}</span>
              </td>
              <td>
                <div class="actions">
                  <div>
                    <IconButton
                      @handle:click="openInfoModal(aula.id_aulas_praticas)"
                      color="secondary"
                      title="Ver informações da aula"
                      :disabled="loadingActions"
                    >
                      <InformationOutline :size="19" />
                    </IconButton>
                  </div>
                </div>
              </td>
            </tr>
          </Table>
        </div>
      </template>
    </Box>

    <InfoModal ref="infoModal" :schema="schema" @refetch="fetchAulas" />

    <!-- <vuestic-modal
      :large="true"
      :show.sync="modal.show"
      ref="smallModal"
      v-bind:small="false"
      :cancelClass="'none'"
      okText="Fechar"
      cancelText="Fechar"
    >
      <div slot="title">Informações</div>

      <div v-show="modal.load">
        <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
          <div
            class="btn-toolbar d-inline-flex"
            role="toolbar"
            aria-label="Toolbar with button groups"
          >
            <component
              :animation-duration="1000"
              :is="'SpringSpinner'"
              :color="'#4AE387'"
              :size="80"
            ></component>
          </div>
        </div>
      </div>

      <div class="p-3" v-if="modal.show">
        <vuestic-tabs
          :names="['Dados Básicos', 'Avaliação', 'Alertas', 'Comportamento', 'Mapa', 'Fotos']"
          ref="tabs"
        >
          <div slot="Dados Básicos">
            <div class="row border-bottom">
              <div class="col-md-12 text-center pt-3 pb-3">
                <strong class="font-weight-bold">Centro de Formação FabricaInfo</strong>
              </div>
            </div>

            <div class="row text-center pt-3 pb-3">
              <div class="col-md-3">
                <strong class="font-weight-bold">Aluno:</strong>
                <p>
                  {{ modal.conteudo.nomeAluno }}
                </p>
                <span style="font-size: medium; font-weight: bold">
                  {{ modal.conteudo.cpfAluno }}
                </span>
              </div>
              <div class="col-md-3">
                <strong class="font-weight-bold">Instrutor:</strong>
                <p>
                  {{ modal.conteudo.nomeInstrutor }}
                </p>
                <span style="font-size: medium; font-weight: bold">
                  {{ modal.conteudo.cpfInstrutor }}
                </span>
              </div>
              <div class="col-md-2">
                <strong class="font-weight-bold">Categoria:</strong>
                <p>
                  {{ modal.conteudo.categoria_cnh }}
                </p>
              </div>
              <div class="col-md-2">
                <strong class="font-weight-bold">Tipo:</strong>
                <p>
                  {{ modal.conteudo.tipo_aula }}
                </p>
              </div>
              <div class="col-md-2">
                <strong class="font-weight-bold">Conteúdo:</strong>
                <p>
                  {{ modal.conteudo.anotacao.edu_content }}
                </p>
              </div>
            </div>

            <div class="row text-center pt-3 pb-3 border-bottom">
              <div class="col-md-3">
                <strong class="font-weight-bold">Modelo:</strong>
                <p>
                  {{ modal.conteudo.modelo }}
                </p>
              </div>
              <div class="col-md-3">
                <strong class="font-weight-bold">Marca:</strong>
                <p>
                  {{ modal.conteudo.marca }}
                </p>
              </div>
              <div class="col-md-2">
                <strong class="font-weight-bold">Cor:</strong>
                <br />
                {{ modal.conteudo.cor }}
              </div>
              <div class="col-md-2">
                <strong class="font-weight-bold">Ano:</strong>
                <br />
                {{ modal.conteudo.ano_modelo }}
              </div>
              <div class="col-md-2">
                <strong class="font-weight-bold">Placa:</strong>
                <br />
                {{ modal.conteudo.placa }}
              </div>
            </div>

            <div class="row text-center pt-3 pb-3">
              <div class="col-md-4">
                <strong class="font-weight-bold">Inicio da Aula (Previsto):</strong>
                <p>
                  {{ utils.formatDate(modal.conteudo.data_aula) }}
                </p>
              </div>
              <div class="col-md-4">
                <strong class="font-weight-bold">Duração (Previsto):</strong>
                <p>50 Minutos</p>
              </div>
              <div class="col-md-4">
                <strong class="font-weight-bold">Fim da aula (Previsto):</strong>
                <p>
                  {{
                    utils.formatDate(
                      modal.conteudo.data_aula.split(' ')[0] +
                        ' ' +
                        new Date(
                          new Date(modal.conteudo.data_aula).getTime() + 50 * 60000
                        ).toLocaleTimeString()
                    )
                  }}
                </p>
              </div>
            </div>

            <div class="row text-center pt-3 pb-3 border-bottom">
              <div class="col-md-4">
                <strong class="font-weight-bold">Inicio da Aula (Real):</strong>
                <p>
                  {{ utils.formatDate(modal.conteudo.anotacao.begin_time) }}
                </p>
              </div>
              <div class="col-md-4">
                <strong class="font-weight-bold">Duração (Real):</strong>
                <p>
                  {{ periodo }}
                </p>
              </div>
              <div class="col-md-4">
                <strong class="font-weight-bold">Fim da aula (Real):</strong>
                <p>
                  {{ utils.formatDate(modal.conteudo.anotacao.finish_time) }}
                </p>
              </div>
            </div>

            <div class="row text-center pt-3 pb-3 border-bottom">
              <div class="col-md-2">
                <strong class="font-weight-bold">Quilometragem inicial:</strong>
                <p>{{ modal.conteudo.anotacao.hodo_start }} Km</p>
              </div>
              <div class="col-md-2">
                <strong class="font-weight-bold">Quilometragem final:</strong>
                <p>{{ modal.conteudo.anotacao.hodo_end }} Km</p>
              </div>
              <div class="col-md-4">
                <strong class="font-weight-bold">Distância percorrida (Hodômetro):</strong>
                <p>
                  {{ modal.conteudo.anotacao.hodo_end - modal.conteudo.anotacao.hodo_start - 1 }} Km
                </p>
              </div>
              <div id="distance_gps" class="col-md-4">
                <strong class="font-weight-bold">Distância percorrida (GPS):<br /></strong>
              </div>
            </div>

            <div class="row text-center pt-3 pb-3">
              <div class="col-md-3">
                <strong class="font-weight-bold">Distância Inicial da Autoescola:</strong>
                <p>
                  <span v-if="this.latIni.distancia_inicio">{{
                    Math.trunc(this.latIni.distancia_inicio * 1000) + ' ' + 'Metros'
                  }}</span>
                  <span v-else>Carregando...</span>
                </p>
              </div>
              <div class="col-md-3">
                <strong class="font-weight-bold">Distância Final da Autoescola:</strong>
                <p>
                  <span
                    v-if="Math.trunc(this.latIni.distancia_fim * 1000) > 500"
                    style="color: red"
                  >
                    {{ Math.trunc(this.latIni.distancia_fim * 1000) + ' ' + 'Metros' }}
                  </span>
                  <span v-else>{{
                    Math.trunc(this.latIni.distancia_fim * 1000) + ' ' + 'Metros'
                  }}</span>
                </p>
              </div>
            </div>

            <div v-if="modal.conteudo.anotacao.finish_reason != null" class="row">
              <div class="col-md-12 text-center">
                <strong class="font-weight-bold" style="color: red">AULA NÃO CONCLUÍDA</strong>
              </div>
              <div class="col-md-12 text-center">
                <strong class="font-weight-bold">Justificativa:</strong>
                {{ modal.conteudo.anotacao.finish_reason }}
              </div>
            </div>

            <div v-if="modal.conteudo.dupla" class="row">
              <div class="col-md-12 text-center">
                <strong class="font-weight-bold" style="color: blue">AULA DUPLA</strong>
              </div>
            </div>

            <div class="row justify-content-center">
              <button
                v-if="!modal.conteudo.anotacao.processada"
                title="Processar Aula"
                class="btn btn-info"
                @click="processarAnotacao(modal.conteudo.anotacao.id_anotacao_pratica)"
              >
                Processar Aula
              </button>
            </div>
          </div>

          <div slot="Avaliação">
            <div class="row justify-content-center text-center">
              <template v-if="modal.conteudo.anotacao.avaliacoes.length > 0">
                <div
                  v-for="avaliacao in modal.conteudo.anotacao.avaliacoes"
                  class="col-md-3 pt-3 pb-3 badge bg-light text-dark"
                  :key="'avaliacao_' + avaliacao.avaliacao_id"
                >
                  <i style="font-size: 18px; padding-right: 5px" class="fa fa-thumbs-up"></i>
                  {{ avaliacao.descricao }}
                </div>
              </template>
              <template v-else>
                <div class="col-md-12">
                  <h5>Nenhuma avaliação</h5>
                </div>
              </template>
            </div>
          </div>

          <div slot="Alertas">
            <div class="row justify-content-center text-center">
              <template v-if="modal.conteudo.anotacao.infracoes.length > 0">
                <table id="alertas_table" class="table table-responsive-sm">
                  <thead>
                    <th>Tipo</th>
                    <th>Descrição</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="infracao in modal.conteudo.anotacao.infracoes"
                      class="tb-linha"
                      :key="'infracao_' + infracao.cod_infracao"
                    >
                      <td>Infração</td>
                      <td style="text-align: left">{{ infracao.detalhe }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template v-else>
                <div class="col-md-12">
                  <h5>Nenhuma infração</h5>
                </div>
              </template>
            </div>
          </div>

          <div slot="Comportamento">
            <div class="row justify-content-center text-center">
              <template v-if="modal.conteudo.anotacao.comportamentos.length > 0">
                <div
                  v-for="comportamento in modal.conteudo.anotacao.comportamentos"
                  class="col-md-3"
                  :key="'comportamento_' + comportamento.id_comportamento_aluno"
                >
                  {{ comportamento.descricao }}
                </div>
              </template>
              <template v-else>
                <div class="col-md-12">
                  <h5>Nenhum comportamento</h5>
                </div>
              </template>
            </div>
          </div>

          <div slot="Mapa">
            <div class="row">
              <div id="mapa" class="col-md-12 text-center justify-content-center">
                <GoogleMap
                  :infractions="modal.conteudo.anotacao.infracoes"
                  :positions="modal.conteudo.anotacao.posicoes"
                  :beginTime="modal.conteudo.data_aula"
                />
              </div>
            </div>
          </div>

          <div slot="Fotos">
            <div class="row">
              <div class="col-md-7" style="height: 400px; overflow: auto">
                <span
                  v-for="(foto, fotoIndex) in modal.conteudo.anotacao.fotos"
                  :key="'foto_' + foto.id_foto_pratica"
                >
                  <img
                    v-if="foto.id_status === 1"
                    :id="'status_' + foto.id_foto_pratica"
                    @click="checkImage(fotoIndex)"
                    class="img-thumb"
                    :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                    alt="Imagem"
                    style="border: solid 5px rgb(255, 0, 0)"
                  />

                  <img
                    v-else-if="foto.id_status === 2"
                    :id="'status_' + foto.id_foto_pratica"
                    @click="checkImage(fotoIndex)"
                    class="img-thumb"
                    :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                    alt="Imagem"
                    style="border: solid 5px rgb(255, 0, 0)"
                  />

                  <img
                    v-else-if="foto.id_status === 3"
                    :id="'status_' + foto.id_foto_pratica"
                    @click="checkImage(fotoIndex)"
                    class="img-thumb"
                    :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                    alt="Imagem"
                    style="border: solid 5px rgb(255, 251, 0)"
                  />

                  <img
                    v-else-if="foto.id_status === 4"
                    :id="'status_' + foto.id_foto_pratica"
                    @click="checkImage(fotoIndex)"
                    class="img-thumb"
                    :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                    alt="Imagem"
                    style="border: solid 5px rgb(9, 255, 0)"
                  />

                  <img
                    v-else
                    @click="checkImage(fotoIndex)"
                    :id="'status_' + foto.id_foto_pratica"
                    class="img-thumb"
                    :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                    alt="Imagem"
                  />
                </span>
              </div>

              <div class="col-md-5">
                <div class="row" style="justify-content: center">
                  <img
                    id="canvas"
                    class="img-monit-modal"
                    alt="Imagem"
                    style="width: 300px; height: 250px"
                  />
                  <div class="container">
                    <div class="row" style="justify-content: center">
                      <table v-if="modal.load" class="table-responsive-sm">
                        <tr>
                          <td>{{ modal.conteudo.anotacao }}</td>
                        </tr>
                      </table>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-12 text-center justify-content-center">
                        <button
                          title="Nenhum aluno detectado"
                          class="btn btn-danger btn-with-icon rounded-icon size"
                          @click="imageStatus(modal.img, 2)"
                        >
                          <span
                            aria-hidden="true"
                            class="fa fa-user-times"
                            style="font-size: 16px; padding-left: 6px"
                          ></span>
                        </button>
                        &nbsp;
                        <button
                          title="Sem imagem"
                          class="btn btn-danger btn-with-icon rounded-icon size"
                          @click="imageStatus(modal.img, 1)"
                        >
                          <span
                            aria-hidden="true"
                            class="fa fa-low-vision"
                            style="font-size: 16px; padding-left: 2px"
                          ></span>
                        </button>
                        &nbsp;
                        <button
                          title="Imagem com erro"
                          class="btn btn-warning btn-with-icon rounded-icon size"
                          @click="imageStatus(modal.img, 3)"
                        >
                          <span
                            aria-hidden="true"
                            class="fa fa-exclamation-triangle"
                            style="font-size: 16px; padding-left: 3px"
                          ></span>
                        </button>
                        &nbsp;
                        <button
                          title="Imagem OK"
                          class="btn btn-success btn-with-icon rounded-icon size"
                          @click="imageStatus(modal.img, 4)"
                        >
                          <span
                            aria-hidden="true"
                            class="fa fa-check"
                            style="font-size: 16px; padding-left: 3px"
                          ></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div style="display: flex" class="col-md-7 pt-3">
                <div class="col-md-6">
                  <span class="badge badge-count-photos">{{
                    modal.conteudo.anotacao.fotos.length
                  }}</span>
                </div>
                <div class="col-md-6" style="align-self: center; align-content: middle">
                  <button
                    title="Validar todas"
                    class="btn btn-success btn-with-icon rounded-icon size float-right"
                    @click="validarTodas(modal.conteudo.anotacao.fotos)"
                  >
                    <span
                      aria-hidden="true"
                      class="fa fa-check"
                      style="font-size: 14px; padding-left: 3px"
                    ></span>
                  </button>
                </div>
              </div>
              <div class="col-md-5"></div>
            </div>
          </div>
        </vuestic-tabs>
      </div>
    </vuestic-modal> -->

    <vuestic-modal
      :show.sync="modal.show"
      ref="fileModal"
      v-bind:small="false"
      cancelClass="none"
      okClass="none"
    >
      <vuestic-tabs :names="['PDF']" ref="tabs">
        <div slot="PDF">
          <div class="row justify-content-center">
            <button class="btn btn-primary" @click="handleDownloadPdf">
              Download {{ this.fileExt }}
            </button>

            <a href="#" hidden id="realizadasPdf"></a>
          </div>
        </div>
      </vuestic-tabs>
    </vuestic-modal>
  </PageContainer>
</template>

<script>
import CloseCircleOutline from 'icons/CloseCircleOutline'
import InformationOutline from 'icons/InformationOutline'
import Magnify from 'icons/Magnify'
import Box from '../core/Box'
import Button from '../core/Button'
import IconButton from '../core/IconButton'
import PageContainer from '../core/PageContainer'
import Paginate from '../core/Paginate'
import Period from '../core/Period'
import Select from '../core/Select'
import Table from '../core/Table'

import InfoModal from './InfoModal'

import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import * as spinners from 'epic-spinners'
import { ModelSelect } from 'vue-search-select'
import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import utils from '../../services/utils'
import GoogleMap from '../google/GoogleMap'
import pagination from '../pagination/pagination'
import AgendamentoController from './AgendamentoController'

export default {
  name: 'AulasAgendadas',
  components: {
    ...spinners,
    PageContainer,
    Box,
    Select,
    Button,
    Period,
    Table,
    Paginate,
    IconButton,
    CloseCircleOutline,
    Magnify,
    InformationOutline,

    InfoModal,

    GoogleMap,
    DateIconGroup,
    pagination,
    ModelSelect,
  },
  data() {
    return {
      schema: localStorage.schema,
      utils: utils,
      aluno: '',
      status: '',
      initialDate: '',
      finalDate: '',
      paginationData: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      alunos: [],
      statusOptions: [],
      aulas: [],
      loaded: true,
      loading: false,
      loadingAluno: false,
      loadingActions: false,

      modal: {
        show: false,
        load: false,
        conteudo: {},
        img: 0,
      },
      fileName: '',
      fileExt: '',
      latIni: '',
      getAulaPraticaStatus: '',
    }
  },
  async created() {
    await Promise.all([this.loadAlunos(), this.fetchStatusOptions()])

    this.loaded = true
  },
  methods: {
    async loadAlunos() {
      this.loadingAluno = true

      await this.$http
        .get(`${urlApiV2}/alunos/consultar/select/${this.schema}`)
        .then(response => {
          this.alunos = response.body.dados.map(aluno => ({ text: aluno.text, value: aluno.text }))
        })
        .catch(err => {
          this.toast(err)
        })
        .finally(() => {
          this.loaded = true
          this.loadingAluno = false
        })
    },
    async fetchStatusOptions() {
      await this.$http.get(`${urlApi}/aulas/praticas/status-aulas-praticas`).then(res => {
        const dados = res.data.dados

        const statusOptions = []
        dados.status.forEach(status => {
          statusOptions.push({ value: status.status, text: status.status })
        })

        this.statusOptions = statusOptions
      })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.fetchAulas()
      }
    },
    validateInputs() {
      if (!this.aluno && (!this.initialDate || !this.finalDate)) {
        this.$toasted.show('Selecione um aluno ou escolha um período.', {
          position: 'top-right',
        })

        return false
      }

      return true
    },
    async fetchAulas(page = 1) {
      this.loading = true

      const params = {
        page,
        aluno: this.aluno,
        status: this.status,
        dataI: this.initialDate,
        dataF: this.finalDate,
      }

      await this.$http
        .get(`${urlApiV2}/aulas/praticas/realizadas`, {
          params,
        })
        .then(res => {
          const response = res.body.dados

          if (response.data.length < 1) {
            this.$toasted.show('Nenhum resultado encontrado!', {
              position: 'top-right',
            })
          }

          this.aulas = response.data

          this.paginationData = {
            currentPage: response.current_page,
            lastPage: response.last_page,
            total: response.total,
          }
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar aulas!', {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInputs() {
      this.aluno = ''
      this.status = ''
      this.initialDate = ''
      this.finalDate = ''
    },
    openInfoModal(aulaId) {
      this.$refs.infoModal.open(aulaId)
    },

    getValue(selector) {
      const element = document.querySelector(selector)
      return element && element.value ? element.value : ''
    },

    processarAnotacao(idAnotacao) {
      let self = this
      self.$http
        .get(urlApi + `/getran/atualizar/pratica/${idAnotacao}`)
        .then(function (response) {
          AgendamentoController.launchToast('fa-check', response.data.dados)
          // console.log(response.data.dados)
          self.modal.show = false
          self.modal.load = false
          self.loadData()
        })
        .catch(function (error) {
          AgendamentoController.launchToast('fa-times', error.data.dados)
          self.modal.show = false
          self.modal.load = false
          self.loadData()
        })
    },
    detalhes(idAulaPratica) {
      let self = this
      this.$refs.smallModal.open()
      self.modal.show = false
      self.modal.load = true
      self.modal.conteudo = {}
      AgendamentoController.getAulaRealizadaById(idAulaPratica, function (response) {
        self.modal.conteudo = response.data.dados
        self.modal.anotacao = response.body.dados.anotacao

        // let hora_inicial = new Date(self.modal.anotacao.begin_time).getTime()
        // let hora_final = new Date(self.modal.anotacao.finish_time).getTime()

        // self.periodo = new Date(hora_final - hora_inicial).getHours() + ':' +new Date(hora_final - hora_inicial).getMinutes()

        const hora_inicial = new Date(self.modal.anotacao.begin_time)
        const hora_final = new Date(self.modal.anotacao.finish_time)

        const diferencaMs = Math.abs(hora_final - hora_inicial)

        // Converte a diferença de tempo para horas, minutos e segundos
        const diferencaSegundos = Math.floor(diferencaMs / 1000)
        const diferencaMin = Math.floor(diferencaMs / 60000)
        const diferencaHoras = Math.floor(diferencaMin / 60)
        const diferencaMinutos = diferencaMin % 60
        const diferencaSegundosRestantes = diferencaSegundos % 60

        // Formata a diferença de tempo com dois dígitos
        const horasFormatadas = diferencaHoras < 10 ? `0${diferencaHoras}` : diferencaHoras
        const minutosFormatados = diferencaMinutos < 10 ? `0${diferencaMinutos}` : diferencaMinutos
        const segundosFormatados =
          diferencaSegundosRestantes < 10
            ? `0${diferencaSegundosRestantes}`
            : diferencaSegundosRestantes
        self.periodo = horasFormatadas + ':' + minutosFormatados + ':' + segundosFormatados

        if (self.modal.conteudo.anotacao.edu_content) {
          self.$http
            .get(urlApi + `/planos/praticos/constante/${self.modal.conteudo.anotacao.edu_content}`)
            .then(function (response) {
              self.modal.conteudo.anotacao.edu_content = response.data
              self.modal.load = false
              self.modal.show = true
              setTimeout(function () {
                self.checkImage(0)
              }, 1000)
            })
        } else {
          self.modal.conteudo.anotacao.edu_content = '-'
          self.modal.load = false
          self.modal.show = true
          setTimeout(function () {
            self.checkImage(0)
          }, 1000)
        }
        let data = {
          aluno: self.modal.conteudo.id_aluno,
          lat: self.modal.conteudo.anotacao.posicoes[0].lat,
          lon: self.modal.conteudo.anotacao.posicoes[0].lon,
          latFim:
            self.modal.conteudo.anotacao.posicoes[self.modal.conteudo.anotacao.posicoes.length - 1]
              .lat,
          lonFim:
            self.modal.conteudo.anotacao.posicoes[self.modal.conteudo.anotacao.posicoes.length - 1]
              .lon,
        }
        self.$http
          .get(urlApi + '/aulas/praticas/distancia/aulapratica', { params: data })
          .then(response => {
            self.latIni = response.body.dados
          })
      })
    },

    openModal(entity, ext) {
      this.fileName = entity
      this.fileExt = ext
      this.$refs.fileModal.open()
    },

    getfile() {
      var ini = document.getElementById('data_ini').value
      var end = document.getElementById('data_end').value

      if (!ini || !end) {
        AgendamentoController.launchToast('fa-times', 'Ops! Preencha as datas corretamente!')
        return
      }

      if (this.fileExt === 'pdf') {
        utils.generatePDF(this.fileName, ini, end, true)
        this.$refs.fileModal.close()
      } else {
        utils.generateTXTorXLSX(this.fileName, this.fileExt, ini, end, true)
        this.$refs.fileModal.close()
      }
    },
    async handleDownloadPdf() {
      const dataAulaI = this.getValue('#dataAulaI')
      const dataAulaF = this.getValue('#dataAulaF')

      await this.$http
        .get(
          `${urlApiV2}/aulas/praticas/realizadas/pdf?status=${this.getAulaPraticaStatus}&dataI=${dataAulaI}&dataF=${dataAulaF}`
        )
        .then(this.downloadPDF)
        .catch(err => {
          console.log(err)
        })
    },
    downloadPDF(response) {
      const code64 = response.body.dados

      const pdf = 'data:application/octet-stream;base64,' + code64

      const dlnk = document.getElementById('realizadasPdf')
      dlnk.download = 'realizadas.pdf'
      dlnk.href = pdf
      dlnk.click()
    },

    // openFoto (data) {
    //   var image = new Image()
    //   image.src = data
    //   image.width = 1280
    //   image.height = 720

    //   var w = window.open('')
    //   w.document.write(image.outerHTML)
    // },

    checkImage(fotoIndex) {
      let self = this

      var foto = self.modal.conteudo.anotacao.fotos[fotoIndex]
      self.modal.img = foto.id_foto_pratica
      var canvas = document.getElementById('canvas')

      canvas.src = 'data:image/' + foto.ext + ';base64, ' + foto.foto

      switch (foto.id_status) {
        case 1:
          canvas.style.border = 'solid 5px rgb(255, 0, 0)'
          break
        case 2:
          canvas.style.border = 'solid 5px rgb(255, 0, 0)'
          break
        case 3:
          canvas.style.border = 'solid 5px rgb(255, 251, 0)'
          break
        case 4:
          canvas.style.border = 'solid 5px rgb(9, 255, 0)'
          break
        default:
          canvas.style.border = 'solid 5px rgb(0, 0, 0, 0.13)'
          break
      }
    },

    posicao(index) {
      let distancia = index - this.table.currentPage
      console.log(distancia)
      if (distancia > -3 && distancia < 1) {
        return true
      }
      return false
    },
    validarTodas(fotos) {
      let idFotos = []
      let border = 'solid 5px rgb(9, 255, 0)'
      fotos.forEach(foto => {
        idFotos.push(foto.id_foto_pratica)
        var thumbImg = document.getElementById('status_' + foto.id_foto_pratica)
        thumbImg.style.border = border
      })

      var canvas = document.getElementById('canvas')
      canvas.style.border = border

      this.validarFoto(idFotos)
    },

    validarFoto(fotos) {
      AgendamentoController.updateFotos(fotos)
    },

    imageStatus(idFoto, type) {
      var border

      AgendamentoController.updateFoto(idFoto, type)

      var canvas = document.getElementById('canvas')
      var thumbImg = document.getElementById('status_' + idFoto)

      switch (type) {
        case 1:
          border = 'solid 5px rgb(255, 0, 0)'
          canvas.style.border = border
          thumbImg.style.border = border
          break
        case 2:
          border = 'solid 5px rgb(255, 0, 0)'
          canvas.style.border = border
          thumbImg.style.border = border
          break
        case 3:
          border = 'solid 5px rgb(255, 251, 0)'
          canvas.style.border = border
          thumbImg.style.border = border
          break
        case 4:
          border = 'solid 5px rgb(9, 255, 0)'
          canvas.style.border = border
          thumbImg.style.border = border
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.aulas-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }

        .input-status {
          max-width: 25.75rem;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .pagination-container {
      align-self: flex-end;
    }
  }

  .actions {
    align-self: flex-end;
  }
}

.form {
  fieldset {
    margin-bottom: 1rem;

    legend {
      font-size: 1.125rem;
    }
  }

  input {
    height: 2.375rem;
  }
}

.table thead tr {
  border-bottom: 0;
}

.buttons-td {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.action-button {
  all: unset;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .fa {
    width: 35px;
    height: 35px;
    line-height: 15px;
    margin: 0px;
    color: white;
    padding: 10px;
    border-radius: 50%;
    box-shadow: black;
  }

  .fa-info {
    background-color: #ffc20e;
    border-color: #ffc20e;
  }

  &:not(:disabled) {
    .fa-info:hover {
      background-color: #ffc30eaa;
    }
  }
}

.img-thumb {
  width: 70px;
  height: 70px;
  border: 1px solid rgba(0, 0, 0, 0.13);
  margin: 5px;
  cursor: pointer;
}

.text-dark {
  color: #212529 !important;
  font-size: 0.85rem;
  line-height: 1.5rem;
}

.badge {
  /* min-width: 5rem;
  display: flex;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.8rem;
  letter-spacing: .0625rem; */
  word-break: break-all;
  white-space: inherit;
  margin: 15px;
  padding: 25px;
  font-weight: 500;
  cursor: default;
  user-select: none;
}

.badge.badge-count-photos {
  font-weight: 500;
  cursor: default;
  background-color: #ccc;
  color: black !important;
  font-size: 14px;
  padding: 15px;
  margin: 0;
}

#maps {
  width: 100% !important;
}

@media (max-width: 1024px) {
  .table {
    width: 100%;
    margin-right: 10px;
    -webkit-margin-right: 25px;
  }
}

@media (max-width: 330px) {
  #downloadButton {
    margin-top: 25px;
    margin-left: 10px;
  }

  .table {
    width: 89%;
    -webkit-width: 90%;
  }
}
</style>
